module.exports = __webpack_public_path__ + "img/5.fca7ae53.png";